import {Injectable} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms'

@Injectable({
  providedIn: 'root'
})
export class GetFormsInvoicesServices {

  constructor(private fb: FormBuilder) {
  }

  TriggerInvoices(): FormGroup {
    return this.fb.group({
      start: this.fb.group({id: [null], name: [null]}),
      CalculationGenerationType: this.fb.group({id: [null, Validators.required], name: [null]}) ,
      offices: []
    });
  }
  InvoicesDetailData(): FormGroup {
    return this.fb.group({
      number: [],
      sfSynchronizationDate: [],
      sapInvoiceTotal: [],
      companyName: [],
      invoiceCode: [],
      invoiceTotal: [],
      sfCustomerOrderID: [],
    });
  }
  InvoicesNumber(): FormGroup {
    return this.fb.group({
      facaboBe: [null, Validators.required],
      facaboFr: [null, Validators.required],
      facaboEs: [null, Validators.required],
      facaboDe: [null, Validators.required],
    });
  }
  ValidationInvoices(): FormGroup {
    return this.fb.group({
      date: [null, Validators.required],
    });
  }
  getFilterHistory(): FormGroup {
    return this.fb.group({
      name: [],
      date: [],
     // started: [],
      status: this.fb.group({ id: [null], name: [null] }),
     // completed: [],
     // created: [],
      recurrence: this.fb.group({ id: [null], name: [null] }),
     // adjustment: this.fb.group({ id: [null], name: [null] }),
    });
  }
  getFilterInvoicesDetail(): FormGroup {
    return this.fb.group({
      code: [],
      logisticCode: [],
      name: [],
      count: [],
      unitPrice: [],
      total: [],
      contract: [],
      productId: this.fb.group({ id: [null], name: [null] }),
    });
  }
}

